import * as React from 'react';
var NotFoundError = /** @class */ (function () {
    function NotFoundError(request) {
        this.request = request;
    }
    return NotFoundError;
}());
export { NotFoundError };
export var NotFound = function (props) {
    throw props.error;
};
export var routeNotFound = function () {
    return function (request, response) {
        var error = new NotFoundError(request);
        response.error = error;
        response.status = 404;
        return React.createElement(NotFound, { error: error });
    };
};
